import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=264f9af1&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports